const data = {
  id: 1,
  title: 'Unscramble the letters to make the correct words.',
  subTitle: 'Sắp xếp các chữ để tạo thành từ đúng.',
  question: 'bear',
  imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/bear.png',
  answer: 'bear',
  settings: {
    question: {
      // shuffedType: 'word',
      shuffedType: 'character',
    },
  },
};

export default data;
